import {useState} from 'react';

import {useTranslation} from 'react-i18next';

import ContactMailIcon from '@mui/icons-material/ContactMail';
import {Grid, SxProps} from '@mui/material';

import {EmailTemplate} from './EmailTemplate';
import {EmpionButton} from '../../../../../../../components/EmpionButton/EmpionButton';
import EmpionDialog from '../../../../../../../components/EmpionDialog/EmpionDialog';

interface Props {
  btnStyles: SxProps;
}

export const SurveyEmailTemplate = ({btnStyles}: Props) => {
  const {t} = useTranslation();
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Grid>
      <EmpionButton onClick={handleOpen} sx={btnStyles}>
        <ContactMailIcon
          fontSize='small'
          sx={{
            marginRight: '4px',
          }}
        />
        {t('companySurveys.actionButtons.emailTemplate')}{' '}
      </EmpionButton>
      <EmpionDialog open={open} onClose={handleClose} showCloseButton>
        <EmailTemplate onClose={handleClose} />
      </EmpionDialog>
    </Grid>
  );
};
